<template>
  <div
    class="campaign-history elevation-2"
    @mouseleave="cardHovered = false"
    @mouseover="cardHovered = true"
  >
    <UCardHeader :header="timestampAgo" :subheader="timestampFull" />
    <div class="campaign-history__body">
      <div class="history_entry">
        <v-list>
          <v-list-tile
            v-for="(link, i) in links"
            :key="i"
            data-tid="link-row"
            ripple
            @click="linkToClipBoard(link)"
          >
            <v-list-tile-content>
              <input :value="link" class="input--invisible" readonly />
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon data-tid="copy-button">file_copy</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </div>
    </div>
  </div>
</template>

<script>
import UCardHeader from "@/components/UCardHeader";

export default {
  components: {
    UCardHeader,
  },
  props: {
    created_at: {
      type: String,
      required: true,
    },
    links: {
      type: Array,
      required: true,
    },
  },
  computed: {
    timestampAgo() {
      return this.$dayjs(this.created_at).fromNow();
    },
    timestampFull() {
      return this.$dayjs(this.created_at).format("MMM DD, YYYY HH:mm");
    },
  },
  methods: {
    linkToClipBoard(str) {
      var el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
  },
};
</script>

<style lang="scss">
.campaign-history {
  @include card();
  margin-bottom: 20px;

  input:focus {
    outline: 0px;
  }
}
</style>
